import { useEffect, useSyncExternalStore } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { createNotificationPreferenceStore } from "../lib/notificationPreferenceStore";

export const notificationPreference = createNotificationPreferenceStore(AsyncStorage);

export function useNotificationPreference() {
  const state = useSyncExternalStore(notificationPreference.subscribe, notificationPreference.getSnapshot, notificationPreference.getSnapshot);
  useEffect(() => { void notificationPreference.load(); }, []);
  return { ...state, setEnabled: notificationPreference.setEnabled };
}
